import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import IndexSectionNavigations13 from "../components/navigations/IndexSectionNavigations13";
import IndexSectionHeaders1 from "../components/headers/IndexSectionHeaders1";
import IndexSectionFeatures2 from "../components/features/IndexSectionFeatures2";
import IndexSectionFeatures12 from "../components/features/IndexSectionFeatures12";
import IndexSectionFeatures10 from "../components/features/IndexSectionFeatures10";
import IndexSectionFeatures9 from "../components/features/IndexSectionFeatures9";
import IndexSectionTestimonials5 from "../components/testimonials/IndexSectionTestimonials5";
import IndexSectionPricing4 from "../components/pricing/IndexSectionPricing4";
import IndexSectionFaq8 from "../components/faq/IndexSectionFaq8";
import IndexSectionContacts6 from "../components/contacts/IndexSectionContacts6";
import IndexSectionCallToAction11 from "../components/call-to-action/IndexSectionCallToAction11";
import IndexSectionFooters7 from "../components/footers/IndexSectionFooters7";

const meta = {
  title: "",
  meta: [],
  link: [],
  style: [],
  script: [],
};

export default function Index() {
  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet {...meta}></Helmet>
      </HelmetProvider>
      <IndexSectionNavigations13 />
      <IndexSectionHeaders1 />
      <IndexSectionFeatures2 />
      <IndexSectionFeatures12 />
      <IndexSectionFeatures10 />
      <IndexSectionFeatures9 />
      <IndexSectionTestimonials5 />
      <IndexSectionPricing4 />
      <IndexSectionFaq8 />
      <IndexSectionContacts6 />
      <IndexSectionCallToAction11 />
      <IndexSectionFooters7 />
    </React.Fragment>
  );
}
